import { Component } from '@angular/core';
import { NavController,NavParams } from 'ionic-angular';
import { AppState } from '../../../app/app.global';

@Component({
  selector: 'page-repeat',
  templateUrl: 'repeat.html'
})
export class RepeatPage {

	trip:any;
	
	repeats = [
		{id:'0',name:'永不'},
		{id:'day',name:'每天'},
		{id:'week',name:'每周'},
		{id:'month',name:'每周'},
		{id:'year',name:'每年'}
	];
	 
  constructor(public navCtrl: NavController,public params: NavParams,public global: AppState) {
			this.trip =  params.data.trip;
  }

  setCalendar(item:any){
	  	if(item){
		  	this.trip.repeatValue = item.id;
		  	this.trip.repeat = item.name;
	  	}
      this.navCtrl.pop();
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/trip/repeat/repeat.ts